import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const RevvField = ({
  title,
  draggable,
  handleDragStart,
  // isRemoveAllowed,
  // removeField,
  // revvFieldID,
  // revvSubField,
}) => (
  <div
    draggable={draggable ? "true" : "false"}
    onDragStart={handleDragStart}
    className="sf-formfield">
    {title}
    {/* {isRemoveAllowed && (
      <i>
        <FontAwesomeIcon
          icon={["far", "times"]}
          onClick={() => {
            removeField(revvFieldID, revvSubField);
          }}
          className=""
        />
      </i>
    )} */}
  </div>
);

RevvField.defaultProps = {
  handleDragStart: () => {},
  draggable: false,
};

export default RevvField;
